// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"53":"profil","75":"beschwerdenNeu","553":"beschwerden"}[chunkId] + "." + {"53":"19ae77a1","75":"2f7075c7","553":"37308f51"}[chunkId] + ".css";
};